import { useState } from 'react';
import axios from 'axios';
import inferSignupChannel from '../utils/inferSignupChannel';
import { trackNewsletterSubscribed } from '../lib/analytics';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      const channel = inferSignupChannel();
      await axios.post(`${API}/newsletter`, { email, signup_channel: channel });
      trackNewsletterSubscribed(channel);
      setStatus('success');
      setEmail('');
    } catch (error) {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#f7f6f3] py-16">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <h3 className="font-display text-3xl mb-4 uppercase">STAY IN THE LOOP</h3>
        <p className="font-body text-gray-700 mb-6">Get the latest athlete stories delivered to your inbox</p>
        
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" data-testid="newsletter-form">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email"
            required
            className="flex-1"
            data-testid="newsletter-email-input"
          />
          <button 
            type="submit" 
            disabled={loading}
            className="btn-pill bg-black text-white disabled:opacity-50"
            data-testid="newsletter-submit-btn"
          >
            {loading ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>
        
        {status === 'success' && (
          <p className="mt-4 text-green-600 font-medium" data-testid="newsletter-success-msg">Successfully subscribed!</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-red-600 font-medium" data-testid="newsletter-error-msg">Something went wrong. Please try again.</p>
        )}
      </div>
    </div>
  );
};

export default NewsletterSignup;
